import { StateStorage } from "zustand/middleware";

function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days = 7) {
  if (typeof document === "undefined") return;
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  const isSecureContext =
    typeof window !== "undefined" && window.location.protocol === "https:";

  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${isSecureContext ? "; Secure" : ""}`;
}

function removeCookie(name: string) {
  if (typeof document === "undefined") return;
  const isSecureContext =
    typeof window !== "undefined" && window.location.protocol === "https:";

  document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax${isSecureContext ? "; Secure" : ""}`;
}

export function setAuthCookie(isAuthenticated: boolean) {
  if (typeof document === "undefined") return;
  const isSecureContext =
    typeof window !== "undefined" && window.location.protocol === "https:";

  if (isAuthenticated) {
    document.cookie = `is-authenticated=true; path=/; max-age=${60 * 60 * 24 * 7}; SameSite=Lax${isSecureContext ? "; Secure" : ""}`;
  } else {
    document.cookie = `is-authenticated=; Max-Age=0; path=/; SameSite=Lax${isSecureContext ? "; Secure" : ""}`;
  }
}

export const cookieZustandStorage: StateStorage = {
  setItem: (name, value) => {
    setCookie(name, value);
  },
  getItem: (name) => {
    return getCookie(name);
  },
  removeItem: (name) => {
    removeCookie(name);
  },
};
